module.exports = new __parcel__URL__("Foto-Awarenes-Forum.410c8747.png").toString();